export const iconFontAwesomeDesignPaintRoller = (
	<i className="fa-solid fa-paint-roller"></i>
);
